import { render, staticRenderFns } from "./notificationMenu.vue?vue&type=template&id=4e69c81a&scoped=true"
import script from "./notificationMenu.vue?vue&type=script&lang=js"
export * from "./notificationMenu.vue?vue&type=script&lang=js"
import style0 from "./notificationMenu.vue?vue&type=style&index=0&id=4e69c81a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e69c81a",
  null
  
)

export default component.exports